import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import ChangePassword from '../components/navbars/ChangePassword';
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo'
import { withRouter } from "react-router-dom";
import parse, { domToReact } from 'html-react-parser';
import Notification from '../components/navbars/Notification';
import BrandLogo from "../components/navbars/BrandLogo";
import '../components/navbars/_navbars.scss';




import { STUDENT_GLOBALS } from "../../utils/studentGlobals";
import CommonHeader from '../components/navbars/CommonHeader';
class PracticeInstructions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false
        }
    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentemail");
            Cookies.remove("registermob");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("role");
            if (Cookies.get("institution_id") == 119) {
                window.location.href = "https://vignan.rizee.in/login";
            } else {
                this.props.history.push("/student/login");
            }
        }
    };
    newTabFunction = () => {
        localStorage.setItem("subjectid", (this.props.history.location.state || {}).subjectid);
        localStorage.setItem("type", "practice");
        localStorage.setItem("ocid", (this.props.history.location.state || {}).ocid);
        localStorage.setItem("otid", (this.props.history.location.state || {}).otid);
        localStorage.setItem("hchaptername", (this.props.history.location.state || {}).hchaptername);
        localStorage.setItem("practice_type", 1);

        window.open("http://localhost:3000/student/subject/practice-test", "_blank") //to open new page
    }
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        console.log("PracticeInstructions", this.props.history.location.state);
        let canceltype = "";
        if ((this.props.history.location.state || {}).etype == "strengthanalysis") {
            canceltype = "strengthanalysis";
        }
        else if ((this.props.history.location.state || {}).etype == "examanalysis") {
            canceltype = "examanalysis";
        }
        else if ((this.props.history.location.state || {}).etype == "homedata") {
            canceltype = "homedata";
        }
        else {
            canceltype = "normal";
        }
        console.log("PracticeInstructions", this.props);

        const studentGlobals = this.props.studentGlobals;
        const loading5 = studentGlobals.loading;
        const error5 = studentGlobals.error;



        if (loading5) return <PreloaderTwo />;
        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        const instructions = studentGlobals.studentGlobals.examInstructions.find((a) => a.is_exam == "0");
        return (
            <div className="PracticeInstructions header-top">
                <CommonHeader color="auto" tone="light" back={true} left={<BrandLogo width="159.501" fill="#ffffff" />} />
                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-between align-items-center">
                        {(this.props.history.location.state || {}).etype == "chapter" ? (
                            <Link to={{
                                pathname: "/student/subjects",
                                state: {
                                    chapters1: (this.props.history.location.state || {}).chapters.chapters1,
                                    subject: (this.props.history.location.state || {}).chapters.subject,
                                    subjectid: (this.props.history.location.state || {}).chapters.subjectid,
                                    getSubjects: (this.props.history.location.state || {}).chapters.getSubjects,
                                    subjectindex: (this.props.history.location.state || {}).chapters.subjectindex,
                                    practice_percentage: (this.props.history.location.state || {}).chapters.practice_percentage,
                                    htitle: (this.props.history.location.state || {}).chapters.htitle,
                                    htitlecount: (this.props.history.location.state || {}).chapters.htitlecount,
                                    totquestions: (this.props.history.location.state || {}).chapters.totquestions,
                                }
                            }} className="my-0 font-weight-normal text-light">
                                <i className="fal fa-arrow-left" /> Back</Link>
                        ) :
                            (this.props.history.location.state || {}).etype == "strengthanalysis" ? (
                                <Link to={{
                                    pathname: "/student/strength-analysis"
                                }} className="my-0 font-weight-normal text-light">
                                    <i className="fal fa-arrow-left" /> Back</Link>
                            ) :
                                (this.props.history.location.state || {}).etype == "homedata" ? (
                                    <Link to={{
                                        pathname: "/student/home"
                                    }} className="my-0 font-weight-normal text-light">
                                        <i className="fal fa-arrow-left" /> Back</Link>
                                )
                                    :
                                    (this.props.history.location.state || {}).etype == "examanalysis" ? (
                                        <Link to={{
                                            pathname: "/student/practice-exam-analysis"
                                        }} className="my-0 font-weight-normal text-light">
                                            <i className="fal fa-arrow-left" /> Back</Link>
                                    ) : (
                                            <Link to={{
                                                pathname: "/student/subjects",
                                                state: {
                                                    chapters1: (this.props.history.location.state || {}).chapters.chapters1,
                                                    subject: (this.props.history.location.state || {}).chapters.subject,
                                                    subjectid: (this.props.history.location.state || {}).chapters.subjectid,
                                                    getSubjects: (this.props.history.location.state || {}).chapters.getSubjects,
                                                    subjectindex: (this.props.history.location.state || {}).chapters.subjectindex,
                                                    practice_percentage: (this.props.history.location.state || {}).chapters.practice_percentage,
                                                    htitle: (this.props.history.location.state || {}).chapters.htitle,
                                                    htitlecount: (this.props.history.location.state || {}).chapters.htitlecount,
                                                    totquestions: (this.props.history.location.state || {}).chapters.totquestions,

                                                }
                                            }} className="my-0 font-weight-normal text-light">
                                                <i className="fal fa-arrow-left" /> Back</Link>
                                        )}

                        <div className="my-2 my-md-0 text-center">
                            <h6 className="title mb-0 mr-4 text-white">Instruction</h6>
                        </div>
                        <div>&nbsp;</div>
                    </Container>
                </div>
                <div className="content-box mt-5" style={{ height: '100vh' }}>
                    <Container fluid>
                        <Row>
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <h6 className="mb-2"><u>Please read the following instructions carefully.</u></h6>
                                {parse(instructions.instructions)}
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-white py-3 border-top shadow-sm">
                    <Container>
                        <Row>
                            {(this.props.history.location.state || {}).type == "error" ? (<Col xl={12} lg={12} md={12} className="text-right">
                                <Link
                                    to={{
                                        pathname: "/student/subject/practice-errortest",
                                        state: {
                                            chapters: (this.props.history.location.state || {}).chapters,
                                            ocid: (this.props.history.location.state || {}).ocid,
                                            otid: "0",
                                            hchaptername: (this.props.history.location.state || {}).hchaptername,
                                            subjectid: (this.props.history.location.state || {}).subjectid,
                                            stateData: (this.props.history.location.state || {}).stateData,
                                            type: "error"
                                        }
                                    }}

                                    className="btn btn-outline-primary px-5">Start Practice</Link>
                            </Col>) : (<Col xl={12} lg={12} md={12} className="text-right">
                                <a
                                    // to={{
                                    //     pathname: "/student/subject/practice-test",
                                    //     state: {
                                    //         canceltype: canceltype,
                                    //         chapters: (this.props.history.location.state || {}).chapters,
                                    //         ocid: (this.props.history.location.state || {}).ocid,
                                    //         otid: (this.props.history.location.state || {}).otid,
                                    //         hchaptername: (this.props.history.location.state || {}).hchaptername,
                                    //         subjectid: (this.props.history.location.state || {}).subjectid,
                                    //         type: "practice"
                                    //     }
                                    // }}
                                    //target="_blank"
                                    onClick={(e) => this.newTabFunction()}

                                    className="btn btn-outline-primary px-5">Start Practice</a>
                            </Col>)}

                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}


export default withRouter(compose(
    graphql(STUDENT_GLOBALS,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                },
                // Shared studentGlobals union; see utils/studentGlobals.
                fetchPolicy: "cache-first"
            }), name: "studentGlobals"
        }))(PracticeInstructions));
